import { Divider } from "@/components/Divider/Divider";
import { Skeleton } from "@/components/Skeleton/Skeleton";

export function FlightFareCardSkeleton() {
  return (
    <div className="section-card flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <Skeleton variant="text" width="40%" height={28} />
        <Skeleton variant="text" width="25%" height={24} />
      </div>

      <Divider color="neutral-soft" />

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Skeleton variant="text" width="45%" height={20} />
          <div className="flex flex-col gap-2">
            {Array.from({ length: 3 }, (_, i) => (
              <div key={i} className="flex items-center gap-1">
                <Skeleton variant="rounded" width={24} height={24} />
                <Skeleton variant="text" width="60%" />
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <Skeleton variant="text" width="40%" height={20} />
          <div className="flex flex-col gap-2">
            {Array.from({ length: 2 }, (_, i) => (
              <div key={i} className="flex items-center gap-1">
                <Skeleton variant="rounded" width={24} height={24} />
                <Skeleton variant="text" width="55%" />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pt-2">
        <Skeleton variant="rounded" width="100%" height={42} />
      </div>
    </div>
  );
}
